import {} from "@redotech/money/currencies"; // for TS2742
import { CreateShippingRateTableInputSchema } from "@redotech/redo-model/integration/redo-in-shipping/shipping-rate-table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { validationResponseSchema } from "./validation-schemas";

export const createShippingMethod = {
  name: "createShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingRateTable: CreateShippingRateTableInputSchema,
    skipValidation: z.boolean().optional(),
  }),
  output: validationResponseSchema,
};
export type CreateShippingMethodInput = z.infer<
  typeof createShippingMethod.input
>;
